import { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { LegalProceedingsProcessDataProps } from './props';
import { LegalProceedingProcessData } from '../../../../../../shared/types/legalProceedings/legalProceedings';
import { cleanObj } from '../../../../../../shared/utils/objects';
import { ISelect, ParamEnum } from '../../../../../../shared/types/shared';
import { asyncGetCities } from '../../../../../../services/location.service';
import { asyncGetParams } from '../../../../../../services/param.service';

export const useLegalProceedingsProcessData = ({
    data,
    onChangeData,
    onChangeFormik,
}: LegalProceedingsProcessDataProps) => {
    const [statusList, setStatusList] = useState<ISelect[]>([]);
    const [processesList, setProcessesList] = useState<ISelect[]>([]);
    const [entitiesList, setEntitiesList] = useState<ISelect[]>([]);
    const [issuesList, setIssuesList] = useState<ISelect[]>([]);
    const [locations, setLocations] = useState<ISelect[]>([]);
    const onSubmit = (data: LegalProceedingProcessData) => {
        if (onChangeData) onChangeData(cleanObj(data) || {});
    };

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
    });

    useEffect(() => {
        if (onChangeFormik) onChangeFormik(formik);
    }, [formik.values, formik.errors]);

    useEffect(() => {
        formik?.setFieldValue('dateReceipt', data?.dateReceipt || '');
        formik?.setFieldValue(
            'registeredCompany',
            data?.registeredCompany || ''
        );
        formik?.setFieldValue('documentClaimant', data?.documentClaimant || '');
        formik?.setFieldValue('nameClaimant', data?.nameClaimant || '');
        formik?.setFieldValue(
            'documentProcessed',
            data?.documentProcessed || ''
        );
        formik?.setFieldValue('nameProcessed', data?.nameProcessed || '');
        formik?.setFieldValue('insuredDocument', data?.insuredDocument || '');
        formik?.setFieldValue('insuredName', data?.insuredName || '');
        formik?.setFieldValue(
            'requirementNumber',
            data?.requirementNumber || ''
        );
        formik?.setFieldValue('fileNumber', data?.fileNumber || '');
        formik?.setFieldValue(
            'namePersonSubscribe',
            data?.namePersonSubscribe || ''
        );
        formik?.setFieldValue('policy', data?.policy || '');
        formik?.setFieldValue('senderEmail', data?.senderEmail || '');
        formik?.setFieldValue('plate', data?.plate || '');
        formik?.setFieldValue('expirationDate', data?.expirationDate || '');
        formik?.setFieldValue('legalProceedings', data?.legalProceedings || '');
        formik?.setFieldValue('pqrIdentified', data?.pqrIdentified || '');
        formik?.setFieldValue('submittingEntity', data?.submittingEntity || '');
        formik?.setFieldValue('address', data?.address || '');
        formik?.setFieldValue('status', data?.status || '');
        formik?.setFieldValue('subject', data?.subject || '');
        formik?.setFieldValue('location', data?.location || '');
        formik?.setFieldValue('detail', data?.detail || '');
    }, [data]);

    useEffect(() => {
        asyncGetParams(ParamEnum.JUDICIAL_STATUS).then((items) =>
            setStatusList(items)
        );

        asyncGetParams(ParamEnum.JUDICIAL_TYPE_PROCESSES).then((items) =>
            setProcessesList(items)
        );

        asyncGetParams(ParamEnum.JUDICIAL_SENDER_ENTITIES).then((items) =>
            setEntitiesList(items)
        );

        asyncGetParams(ParamEnum.JUDICIAL_TYPE_ISSUES).then((items) =>
            setIssuesList(items)
        );

        asyncGetCities().then((items) => setLocations(items));
    }, []);

    return {
        formik,
        statusList,
        processesList,
        entitiesList,
        issuesList,
        locations,
    };
};
